import * as React from "react";

import { Header } from "./components/Header";
import { Experience } from "./components/Experience";
import { Projects } from "./components/Projects";
import { Skills } from "./components/Skills";
import { Contact } from "./components/Contact";
import { Context } from "./Context";

// Lazy load Map component since it includes heavy Mapbox GL library
const Map = React.lazy(() => import("./components/Map").then(module => ({ default: module.Map })));

export function Portfolio() {
  const context: any = React.useContext(Context);
  const className = context.loaded ? "portfolio-loaded" : "portfolio-loading";
  return (
    <div className={className}>
      <Header />
      <Experience />
      <Skills />
      <Projects />
      <Contact />
      <React.Suspense fallback={<div style={{ height: "30vh" }} />}>
        <Map />
      </React.Suspense>
    </div>
  );
}
